import React, { FunctionComponent } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogContentText,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Typography,
    Divider
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Button } from "../Button";
import { IProps, PossibleMatch } from "./IProps";
import { getAxios, route } from "../../utils/endpoints";


const PossibleMatchListItem: FunctionComponent<{ id: number }> = (props) => {
    const [leadData, setLeadData] = React.useState({
        actualFirstname: "",
        actualLastName: "",
        actualAddress: "",
        actualCity: "",
        actualState: "",
        actualZip: "",
        actualPhone: "",
        actualEmail: "",
        otherInfo: "",
        callStatus: "",
        apptDate: new Date(),
        apptTime: "",
        product: "",
        updVersion: 0,
        newDealerId: 0,
        sendEmail: false,
        saleAmount: 0,
        phone2: "",
        id: 0,
        phone3: "",
        email2: "",
        saleStatus: "",
        saleDate: new Date(),
        orderDate: new Date(),
        shipDate: new Date(),
        installDate: new Date(),
        nbrId: 0,
        dialedTollfree: "",
        leadOutcome: "",
        status: "U",
        formDisabled: true,
    });

    const navigate = useNavigate();

    const stringAvatar = (name: string) => {
        return `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;
    }

    const onFetchLead = async () => {
        const response = await getAxios(`${route.apiCallDetail.callDetail}?id=${props.id}`, "GET");
    
        const data = await response.data;

        setLeadData(data);
    }

    React.useEffect(() => {
        onFetchLead();
    }, [])


    return !leadData.actualFirstname ? null : (
        <>
            <ListItem sx={{ "&:hover": { bgcolor: "#DDF1FC", cursor: "pointer" } }} alignItems="flex-start" onClick={() => navigate(`/edit-lead/${leadData.id}`)} >
                <ListItemAvatar>
                    <Avatar sx={{ bgcolor: "#1BA0E9", fontFamily: "Lato", color: "white" }} alt={`${leadData.actualFirstname} ${leadData.actualLastName}`}>{stringAvatar(`${leadData.actualFirstname} ${leadData.actualLastName}`)}</Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <React.Fragment>
                            <Typography
                                sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 15, letterSpacing: 0.5 }}
                            >
                                { leadData.actualFirstname } { leadData.actualLastName }
                            </Typography>
                        </React.Fragment>
                    }
                    secondary={
                        <React.Fragment>
                            <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                            >
                                { leadData.actualEmail }
                            </Typography>
                            {` —  ${leadData.actualPhone}`}
                            <Typography>
                                {leadData.actualAddress } { leadData.actualState }, { leadData.actualZip }
                            </Typography>
                        </React.Fragment>
                    }
                />
            </ListItem>
            <Divider />
        </>
    )
}

export const PossibleMatchesDialog: FunctionComponent<IProps> = (props): JSX.Element => {
    return (
        <Dialog
            fullWidth
            maxWidth="xs"
            open={props.open}
            onClose={props.onClose}
        >
            <DialogTitle sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 22, letterSpacing: 0.5 }}>Possible Matches</DialogTitle>
            <DialogContent>
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                    {
                        props.matches.map((id, index) => {
                            return (
                                <PossibleMatchListItem
                                    id={id}
                                    key={index}
                                />
                            )
                        })
                    }
                </List>
            </DialogContent>
            <DialogActions>
                <Button label="Close" onClick={props.onClose} />
            </DialogActions>
        </Dialog>
    )
}